module.exports = __webpack_public_path__ + "media/BEFIRST_moment04.33297295.mp4";